export const inView = ref => {
    if (!ref) {
        return;
    }
    const {top, bottom} = ref.getBoundingClientRect();
    const viewHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || 0;
    return top < viewHeight && bottom > 0;
};